export const TABS = {
  products: "products",
  pages: "pages",
};
